// Lightweight pub/sub so useQuery can re-fetch after any mutation, without a
// client-side cache to keep in sync (the API is the source of truth).
const listeners = new Set<() => void>();

export function subscribeToInvalidation(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Bumped before each round of listeners runs, so everything reacting to the
 * same invalidation can recognise itself as part of one round. useQuery uses
 * it to collapse the resulting burst into a single request per query, while
 * still starting a genuinely fresh one rather than joining a read that was
 * already in flight before the data changed.
 */
let generation = 0;

export function invalidationGeneration(): number {
  return generation;
}

export function invalidate(): void {
  generation += 1;
  listeners.forEach((listener) => listener());
}
